import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ProjectCurrency } from '../../../core/store/models';

@Component({
    selector: 'ah-project-currency-select',
    templateUrl: './project-currency-select.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProjectCurrencySelectComponent implements OnChanges {
    @Input() currencies: ProjectCurrency[];
    @Input() value: number;
    @Output() change = new EventEmitter();

    options: MenuItem[];
    title: string;
    private defaultTitle = 'Cost (Other)';

    constructor() {
        this.title = this.defaultTitle;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.currencies && changes.currencies.currentValue && changes.currencies.currentValue !== changes.currencies.previousValue) {
            const initialCurr = this.currencies.find(curr => curr.id === this.value);
            this.title = initialCurr ? this.getTitle(initialCurr) : this.defaultTitle;
        }
    }

    buildOptions(currencies: ProjectCurrency[]): MenuItem[] {
        return currencies ? currencies.map(curr => ({ label: this.getTitle(curr), command: () => this.selectCurrency(curr) })) : [];
    }

    getTitle(currency: ProjectCurrency) {
        return `Cost (${currency.accounting_code})`;
    }

    selectCurrency(currency: ProjectCurrency) {
        this.title = this.getTitle(currency);
        this.change.emit(currency.id);
    }
}
